import { UserSubscriptionType } from '~/data/types';

export default function({ store, redirect }) {
  if (store.state.auth.user?.data?.subscription?.type === UserSubscriptionType.AppleIAP) {
    return redirect(301, '/account/billing');
  }
}
